import React, { useEffect } from 'react';
import { compose } from "redux";
import { connect } from "react-redux";
import Users from "./Users";
import {
    addUserTh,
    changeUserPasswordTh,
    deleteUserTh,
    getUsersTh,
    updateUserTh
} from "../../redux/usersReducer";

let mapStateToProps = (state) => ({
    users: state.usersPage.users,
    totalPages: state.usersPage.totalPages,
    totalElements: state.usersPage.totalElements,
    size: state.usersPage.size,
});

const UsersContainer = ({ getUsersTh, users, ...props }) => {
    useEffect(() => {
        getUsersTh(0, 20);
    }, []);

    return (
        <div className="content-wrapper">
            <Users users={users} getUsersTh={getUsersTh} {...props} />
        </div>
    );
};

export default compose(
    connect(mapStateToProps, {
        getUsersTh,
        addUserTh,
        updateUserTh,
        changeUserPasswordTh,
        deleteUserTh,
    })
)(UsersContainer);
